import styled from 'styled-components';

import { StyleColor } from '../../../../../utils/styles-constants';
import { hexToRgba } from '../../../../../utils/style';

interface ColorButtonProps {
	color: string;
}

const Wrapper = styled('div')`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 30px;
`;

const ColorButton = styled('button').attrs({
	type: 'button',
})`
	width: 46px;
	height: 46px;
	padding: 0;
	border: 1px solid ${hexToRgba(StyleColor.White, 10)};
	border-radius: 50%;
	outline: 0;
	background-color: ${({ color }: ColorButtonProps) => color};
	cursor: pointer;

	& + & {
		margin-left: 13px;
	}
`;

export {
	Wrapper,
	ColorButton,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ThemesPanel/ColorsList/styles.ts